export default [
  {key: 'YESTERDAY', label: 'Gestern'},
  {key: 'WEEK', label: '7 Tage'},
  {key: 'MONTH', label: '28 Tage'},
  {key: 'QUARTER', label: '3 Monate'},
  {key: 'YEAR', label: '1 Jahr'},
  {key: 'CUSTOM', label: 'Frei wählbar'},
];
